import { createContext, useContext } from 'react';
import * as React from 'react';

export enum LaunchRoute {
  LaunchView = 'launch_view',
  QuizList = 'quiz_list',
  WorkspaceQuizList = 'workspace_quiz_list',
}

const LaunchContext = createContext<LaunchRoute>(LaunchRoute.LaunchView);

interface LaunchContextProviderProps {
  children: React.ReactNode;
  launchRoute: LaunchRoute;
}

export function LaunchContextProvider({
  children,
  launchRoute,
}: LaunchContextProviderProps) {
  return (
    <LaunchContext.Provider value={launchRoute}>
      {children}
    </LaunchContext.Provider>
  );
}

export function useLaunchRoute() {
  return useContext(LaunchContext);
}
